import {
  ColorsError900,
  ColorsNeutral200,
  ColorsNeutral500,
  ColorsPrimary500,
  Dimensions2,
  Dimensions4,
  Dimensions5,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const dialogTitle = css({
  '&.MuiDialogTitle-root span': {
    textAlign: 'center',
    maxWidth: '90%',
  },
});

const dialogContent = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: Dimensions2,
  marginTop: Dimensions2,
  gap: Dimensions2,
  width: '100%',
  border: `1px solid ${ColorsNeutral200}`,
  borderRadius: '8px',
  padding: `${Dimensions2} ${Dimensions4}`,

  '@media (max-width: 600px)': {
    flexDirection: 'column',
  },
});

const statusText = (status: boolean) =>
  css({
    color: status ? ColorsPrimary500 : ColorsError900,
  });

const roleText = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral500,
  },
});

const dialogActions = css({
  '&.MuiDialogActions-root': {
    display: 'flex',
    justifyContent: 'center',
    gap: Dimensions5,
  },
});

const EditModalStyles = {
  dialogTitle,
  dialogContent,
  statusText,
  roleText,
  dialogActions,
};

export default EditModalStyles;
